<template>
    <departure-area-list-component :dept_area_list=deptAreaList :selected_area=selectedArea
        v-on:selectedArea="selectedArea = $event" />

    <div class="contents_wrap" v-for="(deptArea, deptAreaKey) in deptAreaList">
        <div class="box" v-show="selectedArea == deptArea.id">
            <month-list-component :month_list=dateMomentList[deptAreaKey] :selected_area=selectedArea :selected_month=selectedMonth[deptAreaKey] v-on:selectedMonth="selectedMonth[deptAreaKey] = $event" />

            <div class="transport_table">
                <template v-for="(deptMonth, deptMonthKey) in dateMomentList[deptAreaKey]">
                    <template v-if="destList[deptAreaKey][deptMonth.format('YYYYMM')].length == 0">
                        <table class="m_table01" v-show="selectedMonth[deptAreaKey] == deptMonthKey">
                            <tbody>
                                <tr>
                                    <th>
                                        <div class="no_data">
                                            <div class="text">ツアー情報が見つかりませんでした</div>
                                        </div>
                                    </th>
                                </tr>
                            </tbody>
                        </table>
                    </template>
                    <template v-else>
                        <table class="m_table01" v-show="selectedMonth[deptAreaKey] == deptMonthKey">
                            <tbody>
                                <tr>
                                    <th></th>
                                    <th class="row_head sun">朝発バス</th>
                                    <th class="row_head moon">夜発バス</th>
                                    <th class="row_head bullet">新幹線</th>
                                    <th class="row_head car">マイカー</th>
                                </tr>
                                <tr v-for="(destination, destinationKey) in destList[deptAreaKey][deptMonth.format('YYYYMM')]" v-show="destinationKey < openList[deptAreaKey][deptMonth.format('YYYYMM')]">
                                    <th class="line_head">
                                        <a :href="'/destination/' +  destPrefList[Object.entries(destination.parentIdList)[0][1]].slug + '/' + destination.slug + '/'" class="font-black">
                                            {{destination.name}}
                                        </a>
                                    </th>
                                    <template v-for="(transValue, transKey) in transportationItemList">
                                        <trans-best-price-component
                                            :api_result_list=apiResultList
                                            :date=deptMonth
                                            :trans=transValue
                                            :dept_area=deptArea
                                            :dest=destination
                                            :dest_pref_list=destPrefList
                                            :dest_area_list=destAreaList
                                            v-on:apiResultList="apiResultList[$event] = '読込中'"
                                        />
                                    </template>
                                </tr>
                            </tbody>
                        </table>

                        <div v-show="selectedMonth[deptAreaKey] == deptMonthKey && destList[deptAreaKey][deptMonth.format('YYYYMM')].length >= 5">
                            <div class="more_btn" v-show="openList[deptAreaKey][deptMonth.format('YYYYMM')] <= 5">
                                <div class="button" v-on:click="openList[deptAreaKey][deptMonth.format('YYYYMM')] = 99999">もっと見る</div>
                            </div>
                        </div>
                    </template>
                </template>
            </div>
        </div>
    </div>

    <vue-element-loading :active="isLoading"/>
</template>

<script>
    import { ref, reactive, onMounted } from 'vue'
    export default ({
        props: {
            // 引数の受け問
            month_list : {type: String, require: true},
            dept_area_list : {type: String, require: true},
            dest_area_list : {type: String, require: true},
            dest_pref_list : {type: String, require: true},
            dest_list : {type: String, require: true},
            trans : {type: String, require: true},
        },
        setup (props) {
            const selectedArea = ref("1")
            const selectedMonth = reactive({})
            const apiResultList = reactive({})
            const isLoading = ref(true)
            const openList = reactive({})

            // セットアップ。初期実行
            let monthList = JSON.parse(props.month_list)
            let dateMomentList = {}

            let transportationItemList = JSON.parse(props.trans)
            let deptAreaList = JSON.parse(props.dept_area_list)
            let destAreaList = JSON.parse(props.dest_area_list)
            let destPrefList = JSON.parse(props.dest_pref_list)
            let destList = JSON.parse(props.dest_list)

            Object.keys(deptAreaList).forEach(function (key) {
                let areaDateList = monthList[key]
                let tmpDateMomentList = []
                areaDateList.forEach(function(rawDate){
                    let targetDate = dayjs(rawDate)
                    tmpDateMomentList.push(targetDate)

                    if (!openList[key]) {
                        openList[key] = {}
                    }
                    openList[key][targetDate.format('YYYYMM')] = 5
                })
                
                dateMomentList[key] = tmpDateMomentList
                selectedMonth[key] = 0
            })

            // 完了時
            onMounted(() => {
                let urlList = []
                Object.keys(apiResultList).forEach(function (url) {
                    urlList.push(url)
                })

                if(urlList.length == 0) {
                    isLoading.value = false
                    return;
                }

                axios.post("/api/bestPrice/", {
                    urlList: urlList,
                })
                .then(function (response) {
                    Object.keys(response.data.bestPriceList).forEach(function (url) {
                        if(response.data.bestPriceList[url]) {
                            apiResultList[url] = response.data.bestPriceList[url].price.toLocaleString() + "円～"
                        } else {
                            apiResultList[url] = "-"
                        }
                    })
                    
                    isLoading.value = false
                })
            })

            return {
                dateMomentList,
                transportationItemList,
                deptAreaList,
                selectedArea,
                selectedMonth,
                destAreaList,
                destPrefList,
                destList,
                apiResultList,
                isLoading,
                openList,
            }
        },
    })
</script>